/* Wristify chat widget behaviour. Talks only to the Cloudflare Worker.
   Keeps conversation in sessionStorage so it survives page navigation. */
(function () {
  var root = document.getElementById("wristify-chat");
  if (!root) return;

  var WORKER_URL = root.dataset.workerUrl;
  var GREETING = root.dataset.greeting || "Hi! How can I help?";
  var STORE_KEY = "wf_chat_history";
  var MAX_TURNS = 20;

  var launcher = root.querySelector(".wf-launcher");
  var panel = root.querySelector(".wf-panel");
  var closeBtn = root.querySelector(".wf-panel__close");
  var log = root.querySelector(".wf-log");
  var form = root.querySelector(".wf-composer");
  var input = root.querySelector(".wf-input");
  var sendBtn = root.querySelector(".wf-send");

  var history = loadHistory();
  var busy = false;

  function open() {
    root.classList.add("is-open");
    panel.hidden = false;
    launcher.setAttribute("aria-expanded", "true");
    if (!log.childElementCount) renderHistory();
    setTimeout(function () { input.focus(); }, 220);
  }
  function close() {
    root.classList.remove("is-open");
    launcher.setAttribute("aria-expanded", "false");
    setTimeout(function () { panel.hidden = true; }, 220);
  }
  launcher.addEventListener("click", open);
  closeBtn.addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) close();
  });

  function bubble(role, text) {
    var el = document.createElement("div");
    el.className = "wf-msg wf-msg--" + (role === "user" ? "user" : "bot");
    el.append(linkify(text));
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function renderHistory() {
    log.innerHTML = "";
    bubble("bot", GREETING);
    history.forEach(function (m) { bubble(m.role, m.content); });
    log.scrollTop = log.scrollHeight;
  }

  function showTyping() {
    var el = document.createElement("div");
    el.className = "wf-typing";
    el.innerHTML = "<span></span><span></span><span></span>";
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function linkify(text) {
    var frag = document.createDocumentFragment();
    var re = /(https?:\/\/[^\s]+)/g;
    var last = 0, match;
    while ((match = re.exec(text)) !== null) {
      if (match.index > last) frag.append(text.slice(last, match.index));
      var a = document.createElement("a");
      a.href = match[0];
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.textContent = match[0];
      frag.append(a);
      last = re.lastIndex;
    }
    if (last < text.length) frag.append(text.slice(last));
    return frag;
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || busy) return;

    if (!WORKER_URL) {
      bubble("bot", "Chat isn't configured yet. Please add the Worker URL in the theme editor.");
      return;
    }

    input.value = "";
    bubble("user", text);
    history.push({ role: "user", content: text });
    saveHistory();
    send();
  });

  function send() {
    busy = true;
    sendBtn.disabled = true;
    var typing = showTyping();

    fetch(WORKER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: history.slice(-MAX_TURNS) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        typing.remove();
        var reply = (data && data.reply) || "Sorry, I didn't get that — try again?";
        bubble("bot", reply);
        history.push({ role: "assistant", content: reply });
        saveHistory();
      })
      .catch(function () {
        typing.remove();
        bubble("bot", "I couldn't reach support just now. Please try again in a moment.");
      })
      .finally(function () {
        busy = false;
        sendBtn.disabled = false;
        input.focus();
      });
  }

  function loadHistory() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function saveHistory() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(history.slice(-MAX_TURNS)));
    } catch (e) { /* non-fatal */ }
  }
})();
